import {
  DefaultOptions,
  QueryClient,
  UseMutationOptions,
  UseQueryOptions,
} from '@tanstack/react-query';
import { AxiosError } from 'axios';

const queryConfig: DefaultOptions = {
  queries: {
    refetchOnWindowFocus: false,
  },
};

export const queryClient = new QueryClient({
  defaultOptions: queryConfig,
});

export type ExtractFnReturnType<
  FnType extends (...args: Array<unknown>) => Array<unknown>,
> = Awaited<ReturnType<FnType>>;

export type QueryConfig<
  QueryFnType extends (...args: Array<unknown>) => Array<unknown>,
> = Omit<
  UseQueryOptions<ExtractFnReturnType<QueryFnType>>,
  'queryKey' | 'queryFn'
>;

export type MutationConfig<
  MutationFnType extends (...args: Array<unknown>) => Array<unknown>,
  AxiosErrorT,
  AxiosErrorD,
> = UseMutationOptions<
  ExtractFnReturnType<MutationFnType>,
  AxiosError<AxiosErrorT, AxiosErrorD>,
  Parameters<MutationFnType>[0]
>;
